import { inject, observer } from "mobx-react";
import React from "react";
import { Link } from "react-router-dom";
import { L10n } from "@fidget/common/i18n";
import { parseQueryString } from "@fidget/common/utils";
import { InjectedCurrentUserStore } from "../../../models/currentUser";
import { ICurrentUserStore } from "../../../models/currentUser/CurrentUserStore";
import { getGtmService } from "../../../services/gtmService";
import { BeforeLoginSection } from "../components/beforeLoginSection";
import { WelcomeToHeader } from "../components/welcomeToHeader";
import styles from "./login.css";

interface Props {
  currentUserStore?: ICurrentUserStore;
}

interface State {
  email: string;
}

@inject("currentUserStore")
@observer
export class MagicLink extends React.Component<Props, State> {
  styleType: "login" = "login";
  email?: string;
  private gtmService = getGtmService();

  constructor(props: Props) {
    super(props);
  }

  get injected(): InjectedCurrentUserStore {
    return this.props as InjectedCurrentUserStore;
  }

  componentDidMount() {
    this.gtmService.addGoogleTagManager();
    const { email, token } = parseQueryString();
    this.email = email;
    this.injected.currentUserStore.login({ token });
    this.onResendClicked = this.onResendClicked.bind(this);
  }

  onResendClicked() {
    if (this.email) {
      this.injected.currentUserStore.requestMagicLinkLogin(this.email);
    }
  }

  render() {
    if (this.injected.currentUserStore.loginError) {
      return (
        <div className={styles["login-background"]}>
          <WelcomeToHeader styleType={this.styleType}>
            <BeforeLoginSection styleType={this.styleType}>
              <header>
                <h2>
                  <L10n id={"login.magicLink.expired.title"} values={{ email: this.email }} />
                </h2>
                <p>
                  <L10n id={"login.magicLink.expired.description"} />
                </p>
              </header>
              <form />
              <div>
                <button type={"button"} onClick={this.onResendClicked}>
                  <L10n id={"login.magicLink.expired.sendNewLink"} />
                </button>
              </div>
              <div className={styles.footer}>
                <p>
                  <L10n id={"login.notYourEmail"} />
                </p>
                <p>
                  <Link to={"/"}>
                    <L10n id={"login.backToSignIn"} />
                  </Link>
                </p>
              </div>
            </BeforeLoginSection>
          </WelcomeToHeader>
        </div>
      );
    } else {
      return (
        <div className={styles["login-background"]}>
          <WelcomeToHeader styleType={this.styleType} />
        </div>
      );
    }
  }
}
